var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8956 0.0100436C4.96479 -0.00334788 5.03621 -0.00334788 5.1054 0.0100436L9.56924 0.902812C9.81921 0.951914 10 1.17287 10 1.42731C10 1.68175 9.81921 1.90271 9.56924 1.95181L7.85736 2.29553V3.56996C7.85736 5.14792 6.57846 6.42682 5.0005 6.42682C3.42253 6.42682 2.14364 5.14792 2.14364 3.56996V2.29553L1.07232 2.08127V3.53425L1.42273 5.28407C1.44281 5.38897 1.41603 5.49834 1.34907 5.58092C1.28212 5.6635 1.17945 5.7126 1.07232 5.7126H0.358101C0.250969 5.7126 0.150532 5.66573 0.0813427 5.58092C0.0121532 5.4961 -0.0146299 5.38897 0.00768931 5.28407L0.358101 3.53425V1.93173C0.146068 1.85807 0.000993548 1.6572 0.000993548 1.42731C0.000993548 1.17287 0.181779 0.951914 0.431754 0.902812L4.8956 0.0100436ZM2.49851 7.31289C2.73287 7.237 2.98507 7.32182 3.1547 7.5026L4.73936 9.1877C4.87997 9.33724 5.11879 9.33724 5.2594 9.1877L6.84406 7.5026C7.01369 7.32182 7.2659 7.237 7.50025 7.31289C8.951 7.77936 10 9.13637 10 10.7411C10 11.1205 9.69199 11.4263 9.3148 11.4263H0.686193C0.308999 11.4263 0.000993548 11.1183 0.000993548 10.7411C0.000993548 9.13637 1.05 7.77936 2.49851 7.31289Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentFull);
export default __webpack_public_path__ + "static/media/student-full.4768a93843dbf5f545f5e64e16a67234.svg";
export { ForwardRef as ReactComponent };